import { BaseRepository } from "@/repositories/base-repository"
import { type IMessage } from "@/interfaces/api/message.interface"

export class MessageRepository extends BaseRepository<IMessage> {
  protected resourcePath = "planning/messages"
}
